function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BehaviorSubject, tap } from 'rxjs';
export var BaseFeaturesComponent = /*#__PURE__*/function () {
  function BaseFeaturesComponent(appConfigService) {
    var _this = this;
    _classCallCheck(this, BaseFeaturesComponent);
    _defineProperty(this, "_usercfg_subs_flags", []);
    _defineProperty(this, "_flags", new BehaviorSubject({
      editaAccesoPublico: false,
      editaAceptarLOPD: false,
      editaAceptarRecaptcha: false,
      editaDocAttach: false,
      esAppCandidato: false,
      esAppModifContratos: false
    }));
    this.appConfigService = appConfigService;
    this._usercfg_subs = appConfigService.$usercfg.pipe(tap(function (usercfg) {
      _this._flags.next({
        editaAccesoPublico: usercfg.options.app === 'MODIFCONTRATOS',
        editaAceptarLOPD: usercfg.options.app === 'MODIFCONTRATOS',
        editaAceptarRecaptcha: usercfg.options.app === 'MODIFCONTRATOS',
        editaDocAttach: usercfg.options.app === 'MODIFCONTRATOS',
        esAppCandidato: usercfg.options.app == 'CURR',
        esAppModifContratos: usercfg.options.app == 'MODIFCONTRATOS'
      });
    })).subscribe();
  }
  return _createClass(BaseFeaturesComponent, [{
    key: "$onDestroy",
    value: function $onDestroy() {
      var _this$_usercfg_subs;
      (_this$_usercfg_subs = this._usercfg_subs) === null || _this$_usercfg_subs === void 0 || _this$_usercfg_subs.unsubscribe();
      this._usercfg_subs_flags.forEach(function (s) {
        s.unsubscribe();
      });
    }
  }, {
    key: "autoUnsub",
    value: function autoUnsub(sub) {
      this._usercfg_subs_flags.push(sub);
    }
  }, {
    key: "usercfg",
    get: function get() {
      return this.appConfigService.usercfg;
    }
  }, {
    key: "esAdmin",
    value: function esAdmin() {
      return this.usercfg.adm;
    }
  }]);
}();